import React, {PureComponent} from "react"

import {walletBlueBadge} from "@irati-web/wallet/src/images"
import {Container, Image} from "./styled"

class ModalHeader extends PureComponent {
  render() {
    return (
      <Container>
        <Image src={walletBlueBadge} />
      </Container>
    )
  }
}

export default ModalHeader
